// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-login-page {
  max-width: 400px;
  margin: 80px auto;
  padding: 20px;
}

.login-card {
  padding: 40px;
}

.login-card h1 {
  font-size: 28px;
  margin-bottom: 24px;
  text-align: center;
  color: var(--primary-color);
}

.login-card form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.login-card .form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.login-card label {
  font-weight: 500;
  color: var(--text-dark);
}

.login-card input {
  padding: 12px;
  border: 2px solid var(--border);
  border-radius: 8px;
  font-size: 16px;
}

.login-card input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.login-card .btn {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  margin-top: 8px;
}

@media (max-width: 768px) {
  .admin-login-page {
    margin: 32px auto;
    padding: 16px;
  }

  .login-card {
    padding: 28px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminLogin.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".admin-login-page {\n  max-width: 400px;\n  margin: 80px auto;\n  padding: 20px;\n}\n\n.login-card {\n  padding: 40px;\n}\n\n.login-card h1 {\n  font-size: 28px;\n  margin-bottom: 24px;\n  text-align: center;\n  color: var(--primary-color);\n}\n\n.login-card form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.login-card .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.login-card label {\n  font-weight: 500;\n  color: var(--text-dark);\n}\n\n.login-card input {\n  padding: 12px;\n  border: 2px solid var(--border);\n  border-radius: 8px;\n  font-size: 16px;\n}\n\n.login-card input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.login-card .btn {\n  width: 100%;\n  padding: 14px;\n  font-size: 16px;\n  margin-top: 8px;\n}\n\n@media (max-width: 768px) {\n  .admin-login-page {\n    margin: 32px auto;\n    padding: 16px;\n  }\n\n  .login-card {\n    padding: 28px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
